import {
  CancellationOptionsQuery,
  BookingSpaceCancellationType,
} from '@website/types/graphqlOperations';
import { UseFormReturn } from 'react-hook-form';
import { Alert } from 'react-bootstrap';
import { CancelAim, CancellationFormValues } from './CancellationForm';
import BalanceRefundChangeDates from './descriptions/BalanceRefundChangeDates';
import NoRefundChangeDates from './descriptions/NoRefundChangeDates';
import NoRefundCancel from './descriptions/NoRefundCancel';
import BalanceRefundCancel from './descriptions/BalanceRefundCancel';

/**
 * Cancellation description
 */
export function CancellationDescription({
  cancellationOptions,
  watch,
}: {
  cancellationOptions: CancellationOptionsQuery['booking']['spaces'][0]['cancellationOptions'];
  watch: UseFormReturn<CancellationFormValues>['watch'];
}) {
  // Cancellation type
  const cancellationType = watch('type');
  const cancellationOption = cancellationOptions.find(
    (i) => i.type === cancellationType,
  )!;

  // Number of spaces
  const spaces = parseInt(watch('spaces'));
  const guestRefund = cancellationOption.guestRefund.amountZD * spaces;
  const guestCredits = cancellationOption.guestCredit.amountZD * spaces;
  const { currency } = cancellationOption.guestRefund;

  // Cancellation aim
  const aim = watch('aim');

  // Don't show anything until aim is set
  if (!aim) return null;

  if (
    aim === CancelAim.CHANGE_DATES &&
    cancellationType === BookingSpaceCancellationType.NO_REFUND
  ) {
    return <NoRefundChangeDates />;
  }

  if (
    aim === CancelAim.CHANGE_DATES &&
    cancellationType === BookingSpaceCancellationType.BALANCE_REFUND
  ) {
    return (
      <BalanceRefundChangeDates
        guestRefund={guestRefund}
        guestCredits={guestCredits}
        currency={currency}
      />
    );
  }

  if (
    aim === CancelAim.CANCEL &&
    cancellationType === BookingSpaceCancellationType.NO_REFUND
  ) {
    return <NoRefundCancel />;
  }

  if (
    aim === CancelAim.CANCEL &&
    cancellationType === BookingSpaceCancellationType.BALANCE_REFUND
  ) {
    return (
      <BalanceRefundCancel
        guestRefund={guestRefund}
        guestCredits={guestCredits}
        currency={currency}
      />
    );
  }

  return (
    <Alert variant="danger">
      You are processing an admin only cancellation with a{' '}
      <strong>
        <u>full refund</u>
      </strong>
      ! Please check everything thoroughly.
    </Alert>
  );
}
